import { createFileRoute } from "@tanstack/react-router"

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { ChangePasswordForm } from "@/components/forms/edit-password-form"
import { Header } from "@/components/header"

export const Route = createFileRoute("/_home/settings/change-password")({
  component: ProfilePage,
})

function ProfilePage() {
  return (
    <main className="space-y-4 p-4">
      <Header
        subroutes={[
          {
            route: "#",
            label: "Settings",
          },
        ]}
      >
        Change Password
      </Header>
      <div className="flex h-[80dvh] flex-col items-center justify-center">
        <Card className="mx-auto max-w-4xl overflow-hidden rounded-xl shadow-lg md:w-[60dvw] lg:h-[60dvh] lg:w-[30dvw]">
          <CardHeader>
            <CardTitle>Change Password</CardTitle>
            <CardDescription>Update your password.</CardDescription>
          </CardHeader>
          <CardContent>
            <ChangePasswordForm />
          </CardContent>
        </Card>
      </div>
    </main>
  )
}
